// a context that establishes project rendering mode (model vs collection) from the route

import { createContext, Fragment, useContext } from 'react';
import { Outlet } from 'react-router';

const ProjectModeContext = createContext(null);

export function ProjectModeProvider({ mode, children }) {
	return (
		<ProjectModeContext.Provider value={mode}>
			{/* Both mode branches render the same route children, and react-router
			    creates its nested route wrappers without keys, so switching
			    /projects/:id <-> /projects/v2/:id would otherwise reconcile
			    ProjectProvider/ProjectMapView in place and leak one mode's context
			    state (e.g. pickedTask) into the other. Keying on mode remounts the
			    subtree, so a switch behaves like arriving from the project list. */}
			<Fragment key={mode}>{children ?? <Outlet />}</Fragment>
		</ProjectModeContext.Provider>
	);
}

export function useProjectMode() {
	const mode = useContext(ProjectModeContext);
	if (mode === null) {
		throw new Error('useProjectMode must be used within a ProjectModeProvider');
	}
	return mode;
}
